// 🔧 description_generator.js
// ✅ Purpose: Generates realistic descriptions for LGV Seed Engine entities
// ✅ Features:
// - Creates polished demo descriptions
// - Keeps writing separate from entry generation
// - Future-ready for OpenAI-generated content
// - Reusable across all industries
// - Fully block-commented for clarity and future devs

export const generateDescription = ({
  baseDescription = "",
  color = "",
} = {}) => {
  return `${baseDescription} Finished in ${color}. This seeded demonstration entry showcases the presentation quality and judging experience expected at a modern event.`;
};